export const Selectors = {
	ADVISOR_FORM: '#tankAdvisor-advisorForm',
	CALCULATIONS_CONTAINER: '#tank-advisor-calculation-results',
	RESULTS_CONTAINER: '#tx-ig-tank-advisor-articles',
	ARTICLE: '.advisor-article',
	LOADING_INDICATOR: '#tankAdvisorLoading',
	ZIP_INPUT: '#zip',
	COUNTRY_SELECT: '#tank-advisor-country',
	RANGE_INPUT: '.tankAdvisor-range-input',
	RANGE_INPUT_VALUE: '.range-input-value',
	NUMBER_OF_PEOPLE_SELECTOR: '#numberOfPeopleSelector',
	TANK_SIZE_INPUT: '#tankSize',
	WATER_DEMAND_INPUT: '#waterDemand',
	WATER_YIELD_INPUT: '#waterYield',
	ROOF_COEFFICIENT_INPUT: '#roofCoefficient',
	ROOF_TYPE_SELECT: '#roofType',
	ERROR_YIELD_INSUFFICIENT: '#tank-advisor-error-yieldinsufficient',
	TANK_SIZE_TOOLTIP: '#tank-advisor-size-tooltip',
	PDF_EXPORT_FORM: '#tankAdvisor-exportForm',
	ROOF_AREA_INPUT: '#roofArea',
	ROOF_AREA_DUMMY_INPUT: '#roofAreaDummy',
	EXPORT_PDF_RESULTS: '#export-pdf-results'
};

export const Constants = {
	// defaults
	consumptionByUse: {
		// wc
		0: 13.5,
		// washing
		1: 5.5,
		// cleaning
		2: 2.5
	},
	typesOfUse: {
		TOILET: 0,
		WASHING: 1,
		CLEANING: 2,
		GARDEN: 3
	},
	useAvailableRainwaterInTankSizeCalculation: false,
	precipitationByZip: {
		// de
		0: {
			"01": 630,
			"02": 650,
			"03": 560,
			"04": 560,
			"06": 510,
			"07": 770,
			"08": 1000,
			"09": 1000,
			"10": 550,
			"12": 590,
			"13": 550,
			"14": 540,
			"15": 530,
			"16": 470,
			"17": 550,
			"18": 660,
			"19": 650,
			"20": 800,
			"21": 770,
			"22": 740,
			"23": 660,
			"24": 820,
			"25": 1000,
			"26": 740,
			"27": 780,
			"28": 710,
			"29": 780,
			"30": 650,
			"31": 800,
			"32": 800,
			"33": 850,
			"34": 790,
			"35": 730,
			"36": 900,
			"37": 640,
			"38": 930,
			"39": 530,
			"40": 1100,
			"41": 800,
			"42": 1290,
			"44": 1000,
			"45": 880,
			"46": 1000,
			"47": 740,
			"48": 730,
			"49": 810,
			"50": 1250,
			"51": 1300,
			"52": 810,
			"53": 740,
			"54": 750,
			"55": 510,
			"56": 1130,
			"57": 1150,
			"58": 1220,
			"59": 1460,
			"60": 630,
			"61": 960,
			"63": 710,
			"64": 860,
			"65": 530,
			"66": 1250,
			"67": 650,
			"68": 640,
			"69": 770,
			"70": 680,
			"71": 1040,
			"72": 1590,
			"73": 940,
			"74": 790,
			"75": 790,
			"76": 740,
			"77": 1200,
			"78": 920,
			"79": 1020,
			"80": 1000,
			"81": 950,
			"82": 1200,
			"83": 1660,
			"84": 850,
			"85": 1000,
			"86": 1000,
			"87": 1300,
			"88": 1200,
			"89": 850,
			"90": 850,
			"91": 650,
			"92": 850,
			"93": 950,
			"94": 1250,
			"95": 1100,
			"96": 750,
			"97": 630,
			"98": 910,
			"99": 590
		},
		// at
		1: {
			"10": 591,
			"11": 591,
			"1100": 531,
			"1190": 651,
			"12": 579,
			"13": 591,
			"20": 501,
			"2020": 519,
			"2070": 483,
			"21": 537,
			"2116": 553,
			"2136": 497,
			"2170": 562,
			"22": 463,
			"2273": 463,
			"23": 579,
			"2301": 516,
			"2320": 570,
			"2352": 653,
			"24": 588,
			"2444": 610,
			"2460": 566,
			"25": 666,
			"2500": 666,
			"26": 880,
			"2630": 760,
			"2651": 1000,
			"27": 795,
			"2700": 618,
			"2734": 973,
			"28": 904,
			"2870": 805,
			"2872": 1003,
			"30": 696,
			"31": 696,
			"3100": 696,
			"32": 1049,
			"3263": 1201,
			"3281": 898,
			"33": 1307,
			"3335": 1450,
			"3340": 1165,
			"34": 673,
			"3425": 673,
			"35": 524,
			"3500": 551,
			"3550": 498,
			"36": 1049,
			"37": 614,
			"3763": 614,
			"38": 745,
			"3804": 646,
			"3874": 844,
			"39": 713,
			"3910": 703,
			"3970": 724,
			"40": 830,
			"4020": 871,
			"4063": 790,
			"41": 1016,
			"4150": 993,
			"4154": 1040,
			"42": 865,
			"4204": 942,
			"4240": 789,
			"43": 920,
			"4320": 861,
			"4324": 980,
			"44": 1191,
			"45": 1191,
			"4550": 1003,
			"4560": 1215,
			"4580": 1356,
			"46": 1191,
			"47": 880,
			"4713": 929,
			"4730": 831,
			"48": 1629,
			"4802": 2015,
			"4810": 1214,
			"4820": 1781,
			"4822": 1506,
			"49": 927,
			"4902": 982,
			"4910": 1005,
			"4981": 796,
			"50": 1013,
			"5020": 1195,
			"5083": 832,
			"51": 1295,
			"5163": 1295,
			"52": 1002,
			"5252": 985,
			"5261": 1019,
			"53": 1516,
			"5310": 1566,
			"5360": 1467,
			"54": 951,
			"55": 951,
			"5500": 1039,
			"5550": 1154,
			"5580": 774,
			"5582": 839,
			"56": 1515,
			"5640": 1196,
			"5661": 2263,
			"57": 1557,
			"5700": 1503,
			"5710": 1510,
			"5723": 2403,
			"5743": 999,
			"5753": 1312,
			"60": 873,
			"6020": 911,
			"6074": 823,
			"6080": 873,
			"61": 1031,
			"6100": 1182,
			"6150": 817,
			"6156": 1095,
			"62": 1106,
			"6200": 1117,
			"6290": 1096,
			"63": 1311,
			"6330": 1327,
			"6370": 1295,
			"64": 779,
			"6425": 752,
			"6441": 704,
			"6456": 883,
			"65": 848,
			"6460": 794,
			"6500": 779,
			"6522": 653,
			"6543": 643,
			"6563": 1082,
			"6580": 1139,
			"66": 1309,
			"6600": 1445,
			"6632": 1285,
			"6654": 1199,
			"67": 1533,
			"6754": 1637,
			"6773": 1430,
			"68": 1885,
			"6800": 1360,
			"6886": 2073,
			"6888": 2224,
			"69": 1521,
			"6900": 1521,
			"70": 758,
			"7000": 758,
			"71": 562,
			"7100": 562,
			"72": 588,
			"73": 999,
			"74": 999,
			"7434": 999,
			"75": 678,
			"7503": 678,
			"80": 894,
			"8010": 885,
			"8061": 1004,
			"8073": 786,
			"81": 930,
			"8160": 930,
			"82": 740,
			"8200": 796,
			"8280": 737,
			"8293": 711,
			"8295": 716,
			"83": 856,
			"8301": 856,
			"84": 827,
			"8490": 827,
			"85": 1088,
			"8530": 1071,
			"8551": 1282,
			"8570": 911,
			"86": 994,
			"8600": 716,
			"8623": 915,
			"8630": 1180,
			"8654": 1044,
			"8680": 1116,
			"87": 852,
			"8732": 817,
			"8740": 759,
			"8762": 862,
			"8764": 970,
			"88": 1197,
			"89": 1182,
			"8911": 1295,
			"8943": 992,
			"8952": 1142,
			"8962": 950,
			"8973": 1114,
			"8983": 1222,
			"8990": 1565,
			"90": 893,
			"9020": 893,
			"91": 1341,
			"9135": 1199,
			"9143": 1065,
			"9163": 1952,
			"9170": 1151,
			"92": 923,
			"9210": 923,
			"93": 874,
			"9300": 703,
			"9344": 869,
			"9346": 1148,
			"9360": 779,
			"94": 836,
			"9433": 773,
			"9451": 899,
			"95": 1197,
			"9500": 1093,
			"9521": 1103,
			"9530": 1396,
			"96": 1385,
			"9633": 1395,
			"9652": 1376,
			"97": 1112,
			"9712": 972,
			"9762": 1191,
			"9772": 1175,
			"98": 926,
			"9800": 981,
			"9822": 1058,
			"9843": 807,
			"9872": 859,
			"99": 908,
			"9900": 901,
			"9920": 956,
			"9963": 932,
			"9981": 846
		},
		// ch
		2: {
			"10": 1215,
			"1000": 1181,
			"1009": 1153,
			"1040": 1015,
			"1058": 1431,
			"1097": 1295,
			"11": 1184,
			"1110": 1056,
			"1145": 1312,
			"12": 1284,
			"1200": 1005,
			"1203": 933,
			"1254": 981,
			"1260": 999,
			"1261": 1293,
			"1265": 1895,
			"1276": 1888,
			"13": 1165,
			"1304": 956,
			"1337": 1410,
			"1343": 1692,
			"1346": 1781,
			"1350": 883,
			"1355": 1318,
			"1358": 953,
			"1373": 887,
			"1374": 887,
			"1375": 887,
			"14": 1239,
			"1400": 934,
			"1409": 1037,
			"1413": 963,
			"1446": 1349,
			"1452": 1333,
			"1453": 1333,
			"1454": 1725,
			"15": 1016,
			"1510": 1113,
			"1530": 941,
			"1580": 996,
			"16": 1450,
			"1618": 1596,
			"1619": 1225,
			"1623": 1506,
			"1633": 1249,
			"1636": 1247,
			"1654": 1681,
			"1656": 1745,
			"1660": 1353,
			"17": 1233,
			"1700": 1075,
			"1712": 1127,
			"1716": 1253,
			"1718": 1334,
			"1738": 1551,
			"1784": 1062,
			"18": 1449,
			"1800": 1270,
			"1833": 1759,
			"1860": 1012,
			"1862": 1694,
			"1865": 1593,
			"1875": 1843,
			"1880": 1051,
			"1882": 1373,
			"19": 928,
			"1920": 855,
			"1923": 1342,
			"1925": 1226,
			"1934": 852,
			"1937": 786,
			"1946": 929,
			"1948": 1172,
			"1950": 603,
			"1983": 736,
			"1987": 786,
			"20": 1149,
			"2000": 978,
			"2043": 1180,
			"2067": 1289,
			"21": 1273,
			"2108": 1273,
			"22": 1149,
			"23": 1516,
			"2300": 1441,
			"2316": 1552,
			"2350": 1555,
			"24": 1553,
			"2400": 1531,
			"2406": 1597,
			"2416": 1533,
			"25": 1295,
			"2500": 1187,
			"2501": 1187,
			"2518": 1487,
			"2532": 1405,
			"2538": 1209,
			"26": 1505,
			"2608": 1373,
			"2610": 1638,
			"27": 1274,
			"2713": 1430,
			"2740": 1118,
			"28": 1148,
			"2800": 908,
			"2807": 1233,
			"2827": 1221,
			"2884": 1231,
			"29": 1090,
			"2916": 1090,
			"30": 1133,
			"3046": 1207,
			"3052": 1059,
			"31": 1219,
			"3123": 1143,
			"3150": 1296,
			"32": 1015,
			"3203": 1021,
			"3236": 988,
			"3270": 1059,
			"3280": 1008,
			"3284": 999,
			"33": 1148,
			"3360": 1148,
			"34": 1212,
			"3400": 1111,
			"3401": 1111,
			"3402": 1111,
			"3425": 1088,
			"3457": 1643,
			"35": 1462,
			"3506": 1304,
			"3550": 1376,
			"3557": 1708,
			"36": 1124,
			"3600": 959,
			"3616": 1261,
			"3629": 1018,
			"3638": 1260,
			"37": 1351,
			"3702": 1321,
			"3714": 1237,
			"3715": 1624,
			"3718": 1192,
			"3723": 1232,
			"3724": 1237,
			"3725": 1237,
			"3752": 1396,
			"3758": 1308,
			"3762": 1308,
			"3766": 1404,
			"3770": 1352,
			"3780": 1382,
			"3785": 1684,
			"38": 1405,
			"3800": 1196,
			"3801": 1631,
			"3802": 1151,
			"3818": 1384,
			"3822": 1207,
			"3825": 1490,
			"3855": 1325,
			"3860": 1375,
			"3863": 1644,
			"3864": 1650,
			"39": 938,
			"3902": 699,
			"3906": 868,
			"3907": 1252,
			"3919": 1084,
			"3920": 639,
			"3922": 545,
			"3925": 653,
			"3930": 596,
			"3954": 1221,
			"3960": 672,
			"3961": 850,
			"3963": 692,
			"3984": 1000,
			"3988": 1212,
			"3996": 1162,
			"3999": 1856,
			"40": 897,
			"41": 897,
			"4102": 842,
			"4125": 818,
			"4145": 1033,
			"42": 1050,
			"4242": 1050,
			"43": 1081,
			"4313": 1081,
			"44": 1141,
			"4418": 1234,
			"4422": 1032,
			"4438": 1342,
			"4450": 1025,
			"4458": 1206,
			"4497": 1009,
			"45": 1428,
			"4515": 1737,
			"4533": 1388,
			"4577": 1161,
			"46": 1025,
			"4612": 1025,
			"47": 1182,
			"4710": 1117,
			"4715": 1247,
			"48": 1140,
			"4800": 1140,
			"49": 1209,
			"4915": 1178,
			"4923": 1129,
			"4934": 1183,
			"4950": 1276,
			"4952": 1282,
			"50": 1130,
			"5013": 1009,
			"5015": 1301,
			"5033": 1076,
			"5064": 1137,
			"5070": 1094,
			"5080": 1166,
			"51": 1130,
			"52": 1078,
			"5224": 1088,
			"5225": 1088,
			"5243": 1058,
			"53": 1057,
			"5312": 1069,
			"5325": 1045,
			"54": 1127,
			"5420": 1150,
			"5466": 1104,
			"55": 1197,
			"56": 1197,
			"5630": 1197,
			"57": 1167,
			"5707": 1126,
			"5726": 1209,
			"60": 1510,
			"6000": 1173,
			"6010": 2081,
			"6013": 1797,
			"6025": 1239,
			"6060": 1182,
			"6067": 1760,
			"6074": 1304,
			"6078": 1544,
			"61": 1606,
			"6156": 1478,
			"6162": 1503,
			"6163": 1503,
			"6173": 1794,
			"6174": 1794,
			"6182": 1504,
			"6192": 1504,
			"6196": 1768,
			"62": 1146,
			"6204": 1126,
			"6215": 1239,
			"6222": 1239,
			"6243": 1051,
			"6295": 1078,
			"63": 1396,
			"6300": 1342,
			"6313": 1481,
			"6330": 1125,
			"6340": 1395,
			"6370": 1317,
			"6388": 1559,
			"6390": 1559,
			"64": 1664,
			"6403": 1337,
			"6417": 1815,
			"6418": 1830,
			"6430": 1718,
			"6436": 2196,
			"6460": 1186,
			"6461": 1646,
			"6465": 2010,
			"6475": 1455,
			"6487": 1567,
			"6490": 1552,
			"65": 1648,
			"6500": 1579,
			"6537": 1476,
			"6544": 1671,
			"6563": 1514,
			"6565": 1622,
			"6573": 1832,
			"6574": 1843,
			"66": 2015,
			"6600": 1897,
			"6611": 2084,
			"6614": 2071,
			"6637": 2134,
			"6645": 1583,
			"6659": 2312,
			"6675": 1713,
			"6685": 1922,
			"6690": 2420,
			"67": 1486,
			"6710": 1640,
			"6716": 1318,
			"6718": 1435,
			"6746": 1473,
			"6747": 1473,
			"6748": 1473,
			"6749": 1473,
			"6760": 1473,
			"6763": 1473,
			"6764": 1473,
			"6776": 1457,
			"6780": 1675,
			"68": 1751,
			"6808": 2153,
			"6838": 1803,
			"6855": 1515,
			"6877": 1533,
			"69": 1685,
			"6900": 1559,
			"6988": 1811,
			"70": 1170,
			"7000": 849,
			"7015": 1144,
			"7017": 1282,
			"7018": 1282,
			"7019": 1282,
			"7050": 1365,
			"7064": 1098,
			"7078": 1059,
			"71": 1140,
			"7107": 1071,
			"7130": 992,
			"7132": 1338,
			"7144": 1043,
			"7149": 1147,
			"7156": 1148,
			"7162": 1161,
			"7166": 1119,
			"7180": 1101,
			"7188": 1283,
			"72": 1166,
			"7214": 1269,
			"7240": 1119,
			"7246": 1487,
			"7250": 1409,
			"7260": 1411,
			"7265": 1022,
			"7270": 1022,
			"7272": 1022,
			"7276": 1022,
			"7277": 1022,
			"7278": 1029,
			"73": 1216,
			"7302": 1073,
			"7310": 1114,
			"7315": 1116,
			"7320": 1334,
			"7326": 1444,
			"74": 1082,
			"7405": 888,
			"7430": 889,
			"7435": 1406,
			"7438": 1598,
			"7440": 981,
			"7445": 1236,
			"7446": 1143,
			"7447": 1143,
			"7448": 1143,
			"7450": 817,
			"7457": 1248,
			"7460": 928,
			"7477": 915,
			"7484": 973,
			"7492": 990,
			"7494": 1022,
			"75": 833,
			"7503": 713,
			"7504": 1295,
			"7530": 879,
			"7536": 760,
			"7537": 696,
			"7542": 888,
			"7550": 706,
			"7560": 732,
			"76": 1448,
			"7603": 1464,
			"7610": 1432,
			"77": 1264,
			"7710": 1738,
			"7742": 1434,
			"7743": 971,
			"7744": 916,
			"80": 1094,
			"8044": 1134,
			"8046": 1054,
			"81": 1168,
			"8112": 1114,
			"8135": 1386,
			"8143": 1254,
			"8152": 1188,
			"8180": 999,
			"8196": 1068,
			"82": 926,
			"8200": 907,
			"8215": 865,
			"8217": 961,
			"8226": 901,
			"8232": 1006,
			"8235": 944,
			"8253": 868,
			"8263": 851,
			"8264": 947,
			"8266": 942,
			"8272": 996,
			"83": 1263,
			"8302": 1048,
			"8307": 1140,
			"8330": 1223,
			"8340": 1351,
			"8356": 1184,
			"8360": 1297,
			"8376": 1603,
			"84": 1216,
			"8400": 1143,
			"8450": 917,
			"8494": 1590,
			"85": 1001,
			"8500": 1073,
			"8507": 986,
			"8525": 906,
			"8536": 993,
			"8556": 1017,
			"8570": 980,
			"8580": 1049,
			"8583": 1061,
			"8594": 947,
			"86": 1237,
			"8610": 1186,
			"8627": 1319,
			"8637": 1024,
			"8645": 1420,
			"87": 1688,
			"8700": 1229,
			"8717": 1555,
			"8718": 1691,
			"8726": 1876,
			"8750": 1903,
			"8751": 1836,
			"8754": 1507,
			"8755": 1507,
			"8758": 1647,
			"8767": 1619,
			"8783": 1802,
			"8784": 2095,
			"88": 1864,
			"8820": 1390,
			"8836": 1791,
			"8841": 1880,
			"8842": 2504,
			"8843": 2023,
			"8844": 1882,
			"8849": 2146,
			"8853": 1504,
			"8854": 1562,
			"8857": 1824,
			"8858": 2184,
			"8872": 1688,
			"89": 1230,
			"8909": 1134,
			"8910": 1290,
			"8915": 1388,
			"8953": 1110,
			"90": 1558,
			"9000": 1324,
			"9034": 1425,
			"9036": 1425,
			"9043": 1654,
			"9050": 1537,
			"9053": 1559,
			"9057": 1803,
			"9058": 1740,
			"91": 1672,
			"9100": 1435,
			"9107": 2555,
			"9113": 1511,
			"9116": 1511,
			"9122": 1365,
			"9127": 1657,
			"92": 1204,
			"9220": 1040,
			"9230": 1287,
			"9231": 1287,
			"93": 995,
			"9320": 995,
			"94": 1275,
			"9443": 1205,
			"9450": 1461,
			"9465": 1229,
			"9470": 1686,
			"9475": 1321,
			"9490": 923,
			"9494": 1100,
			"95": 1191,
			"9502": 1133,
			"9533": 1398,
			"9556": 1043,
			"96": 2197,
			"9633": 1927,
			"9642": 1828,
			"9658": 2837
		},
		// fr
		3: {
			"01": 1275,
			"02": 742,
			"03": 809,
			"04": 843,
			"05": 895,
			"06": 967,
			"07": 1244,
			"08": 905,
			"09": 997,
			"10": 755,
			"11": 859,
			"12": 1036,
			"13": 766,
			"14": 862,
			"15": 1229,
			"16": 860,
			"17": 855,
			"18": 759,
			"19": 1250,
			"20": 838,
			"21": 863,
			"22": 816,
			"23": 1012,
			"24": 890,
			"25": 1368,
			"26": 965,
			"27": 708,
			"28": 649,
			"29": 964,
			"30": 960,
			"31": 832,
			"32": 797,
			"33": 901,
			"34": 927,
			"35": 772,
			"36": 777,
			"37": 683,
			"38": 1177,
			"39": 1980,
			"40": 1114,
			"41": 670,
			"42": 859,
			"43": 822,
			"44": 761,
			"45": 679,
			"46": 976,
			"47": 810,
			"48": 1299,
			"49": 830,
			"50": 986,
			"51": 752,
			"52": 930,
			"53": 794,
			"54": 833,
			"55": 983,
			"56": 911,
			"57": 869,
			"58": 937,
			"59": 729,
			"60": 714,
			"61": 805,
			"62": 824,
			"63": 965,
			"64": 1399,
			"65": 1157,
			"66": 712,
			"67": 840,
			"68": 1162,
			"69": 838,
			"70": 1145,
			"71": 858,
			"72": 716,
			"73": 1151,
			"74": 1458,
			"75": 633,
			"76": 895,
			"77": 716,
			"78": 633,
			"79": 851,
			"80": 755,
			"81": 990,
			"82": 809,
			"83": 858,
			"84": 765,
			"85": 795,
			"86": 733,
			"87": 1061,
			"88": 1238,
			"89": 794,
			"90": 1075,
			"91": 633,
			"92": 633,
			"93": 633,
			"94": 633,
			"95": 633
		}
	},
	countryCodes: {
		0: 'de',
		1: 'at',
		2: 'ch',
		3: 'fr'
	}
};
